import { OrderStatusType } from '@/@types/order';
import { Order } from '@/apis/order/interface';
import { processStatus } from '@/utils/tableFormat';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
  order: Order;
}

const useOrderStatus = ({ order }: Props) => {
  const location = useLocation();
  const currentpath = location.pathname.split('/')[1];

  const orderStatus = processStatus(order, currentpath);

  const [orderViewStatus, setOrderViewStatus] =
    useState<OrderStatusType>(orderStatus);

  useEffect(() => {
    setOrderViewStatus(orderStatus);
  }, [order]);

  return {
    orderStatus,
    orderViewStatus,
    onChangeOrderViewStatus: setOrderViewStatus
  };
};

export default useOrderStatus;
